<div
    id="{{drawAreaId}}"
    cdkDropList
    cdkDropListSortingDisabled
    [cdkDropListConnectedTo]="['skill-architecture-selection-row']"
    class="h-100 w-100"
    [ngClass]="{'disable-editing': editingIsDisabled}"
    (cdkDropListDropped)="onLayerDrop($event)"
></div>
